
export const SEARCH_INPUT_TYPES = {
    CHECKBOX: 'CHECKBOX',
    DATEPICKER: 'DATEPICKER',
    DROPDOWN: 'DROPDOWN',
    INPUT: 'INPUT'
};

export const SEARCH_INPUT_NAMES = {
    AFTER_DATE: 'afterDate',
    BEFORE_DATE: 'beforeDate',
    CONTAINS_TAG: 'containsTag',
    CONTAINS_WORKGROUP: 'containsWorkgroup',
    NAME: 'name',
    ROLE: 'role',
    TAG: 'tag',
    UNTAGGED: 'untagged',
    WORKGROUP: 'workgroup'
};

export const MANDATORY_INPUT_NAMES_FOR_DATE_SEARCH = [
    SEARCH_INPUT_NAMES.NAME,
    SEARCH_INPUT_NAMES.ROLE,
    SEARCH_INPUT_NAMES.TAG,
    SEARCH_INPUT_NAMES.WORKGROUP
];

export const SEARCH_INPUT_DEFAULTS = {
    [SEARCH_INPUT_NAMES.AFTER_DATE]: null,
    [SEARCH_INPUT_NAMES.BEFORE_DATE]: null,
    [SEARCH_INPUT_NAMES.CONTAINS_TAG]: true,
    [SEARCH_INPUT_NAMES.CONTAINS_WORKGROUP]: true,
    [SEARCH_INPUT_NAMES.NAME]: '',
    [SEARCH_INPUT_NAMES.ROLE]: null,
    [SEARCH_INPUT_NAMES.TAG]: null,
    [SEARCH_INPUT_NAMES.UNTAGGED]: false,
    [SEARCH_INPUT_NAMES.WORKGROUP]: null
};

export const BOUND_PARAMS = [
    [ SEARCH_INPUT_NAMES.CONTAINS_TAG, SEARCH_INPUT_NAMES.TAG ],
    [ SEARCH_INPUT_NAMES.CONTAINS_WORKGROUP, SEARCH_INPUT_NAMES.WORKGROUP ]
];

export const CORRESPONDING_DATES = {
    [SEARCH_INPUT_NAMES.AFTER_DATE]: SEARCH_INPUT_NAMES.BEFORE_DATE,
    [SEARCH_INPUT_NAMES.BEFORE_DATE]: SEARCH_INPUT_NAMES.AFTER_DATE
};